import { useApiClient } from '../../hooks/useApiClient';
import { FeedbackType } from '../../types/Feedback/FeedbackType.type';

export const useFeedbackTypeApi = () => {
  const apiClient = useApiClient();

  return {
    getFeedbackTypes: (): Promise<FeedbackType[]> => apiClient(`/feedback_types/`),
  };
};
